import React from 'react'
import { AlertIcon, Toast } from '@diversioteam/diversio-ds'

import { useDuplicatePulseSurvey } from 'hooks/pulseSurveys/useDuplicatePulseSurvey'
import { useGetPulseSurveyDetail } from 'hooks/pulseSurveys/useGetPulseSurveyDetail'
import { PulseSurveysError } from 'containers/PulseSurveys/Error'

import { PreviewProps } from './preview.types'
import * as S from './preview.styles'

export const Preview = ({ surveyUUID, children }: PreviewProps) => {
    const { mutate } = useDuplicatePulseSurvey()

    const { data, isError } = useGetPulseSurveyDetail({ surveyUUID })

    const handleDuplicateSurvey = () => {
        mutate({ survey: surveyUUID })
    }

    if (!data) {
        return null
    }

    const { title, description, disclaimer, ask_email: askEmail } = data

    if (isError) {
        return <PulseSurveysError surveyUUID={surveyUUID} isPreviewMode />
    }

    return (
        <S.PreviewWrapper>
            <Toast
                open={true}
                type="warning"
                message="Preview mode. To make changes, duplicate it first."
                icon={<AlertIcon type="line" />}
                buttonLabel="Duplicate & Edit"
                onClick={handleDuplicateSurvey}
            />

            <S.FieldInactiveWrapper previewMode={true}>
                <S.Header>
                    <S.SurveyTitle>{title}</S.SurveyTitle>
                </S.Header>

                <S.Description>
                    {description}
                    {`\n\r\n`}
                    {disclaimer}
                </S.Description>

                <S.Footer>
                    <S.Required>* Indicates required questions</S.Required>
                </S.Footer>
            </S.FieldInactiveWrapper>

            {askEmail && (
                <S.FieldInactiveWrapper previewMode={true}>
                    <S.Header>
                        <S.Title>Email</S.Title>

                        <S.Required>*Required</S.Required>
                    </S.Header>

                    <S.TextField>Enter respondent email</S.TextField>
                </S.FieldInactiveWrapper>
            )}

            {children}
        </S.PreviewWrapper>
    )
}
